import { getContainerHeight } from 'helpers/commonHelper';
import React, { createRef, PureComponent, RefObject } from 'react';
import withContext from '../../../hoc/withContext';
import withTextContext from '../../../hoc/withTextContext';

interface IProps extends IAccordionWrapper, IContext {
  paymentMethods: IMethod[];
  formData: IFormData;
}

class BlikRedirect extends PureComponent<IProps> {
  containerRef: RefObject<HTMLDivElement> = createRef();

  componentDidMount() {
    const { setHeight } = this.props;
    setHeight(getContainerHeight(this.containerRef.current));
  }

  componentDidUpdate() {
    const { setHeight } = this.props;
    setHeight(getContainerHeight(this.containerRef.current));
  }

  render() {
    return <></>;
  }
}

export default withContext(withTextContext(BlikRedirect));
